import React, { useState } from "react";
import emailjs from "emailjs-com";
import { Container, Grid, TextField, Button, Checkbox, FormControlLabel, Typography, Box } from "@mui/material";
import { Link } from "react-router-dom";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    message: "",
    consent: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_6bdzeho", // Replace with your EmailJS Service ID
        "template_9o36lcs", // Replace with your EmailJS Template ID
        {
          first_name: formData.first_name,
          last_name: formData.last_name,
          email: formData.email,
          phone: formData.phone,
          message: formData.message,
          consent: formData.consent ? "Yes" : "No",
        },
        "2CKd8PIWzRbxVTbZi" // Replace with your EmailJS Public Key
      )
      .then(
        (response) => {
          alert("Message sent successfully!");
          console.log("SUCCESS!", response.status, response.text);
          setFormData({ first_name: "", last_name: "", email: "", phone: "", message: "", consent: false });
        },
        (error) => {
          alert("Failed to send message. Please try again later.");
          console.log("FAILED...", error);
        }
      );
  };

  return (
    <Container maxWidth="xl" id="contact-form" disableGutters sx={{ width: "98vw", minHeight: "100vh", display: "flex" }}>
      <Grid container sx={{ width: "100%", height: "100%" }}>
        {/* Google Map Section */}
        <Grid item xs={12} md={6} sx={{ height: "100vh" }}>
          <iframe
            title="Google Map"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3108.472150640273!2d-94.34831812412268!3d38.64960467133624!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87c0f20e9a12bbcd%3A0x9a6f0a734db8c9b3!2s117%20S%20Lexington%20St%2C%20Harrisonville%2C%20MO%2064701!5e0!3m2!1sen!2sus!4v1707200000000"
  
          ></iframe>
        </Grid>

        {/* Contact Form Section */}
        <Grid item xs={12} md={6} sx={{ backgroundColor: "#1C1C1C", color: "white", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
          <Box sx={{ maxWidth: "600px", width: "100%" }}>
            <Typography variant="h6" sx={{ fontWeight: "bold", textTransform: "uppercase", mb: 2 }}>
              Contact Us
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: "bold", mb: 3 }}>
              Have Questions? <br /> Get in touch!
            </Typography>

            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="First Name" name="first_name" variant="outlined" value={formData.first_name} onChange={handleChange} InputLabelProps={{ style: { color: "white" } }} sx={{ backgroundColor: "#1B294A", borderRadius: "4px", input: { color: "white" } }} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Last Name" name="last_name" variant="outlined" value={formData.last_name} onChange={handleChange} InputLabelProps={{ style: { color: "white" } }} sx={{ backgroundColor: "#1B294A", borderRadius: "4px", input: { color: "white" } }} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Email" name="email" type="email" variant="outlined" value={formData.email} onChange={handleChange} InputLabelProps={{ style: { color: "white" } }} sx={{ backgroundColor: "#1B294A", borderRadius: "4px", input: { color: "white" } }} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Phone" name="phone" type="tel" variant="outlined" value={formData.phone} onChange={handleChange} InputLabelProps={{ style: { color: "white" } }} sx={{ backgroundColor: "#1B294A", borderRadius: "4px", input: { color: "white" } }} />
                </Grid>
                <Grid item xs={12}>
                  <TextField fullWidth label="Message" name="message" variant="outlined" multiline rows={4} value={formData.message} onChange={handleChange} InputLabelProps={{ style: { color: "white" } }} sx={{ backgroundColor: "#1B294A", borderRadius: "4px", input: { color: "white" } }} />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel control={<Checkbox name="consent" checked={formData.consent} onChange={handleChange} sx={{ color: "white" }} />} label={<Typography sx={{ color: "white" }}>   I agree to receive SMS messages from Infinity Autoship LLC related to my
                  inquiries, transactions, and promotional offers.</Typography>} />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" sx={{ color: "white", mb: 1 }}>
                    By submitting this form, you agree to our
                    <Link to="#" style={{ color: "#FFCB42", textDecoration: "none", marginLeft: "0.5rem" }}>Privacy Policy</Link>
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Button type="submit" fullWidth variant="contained" sx={{ backgroundColor: "#FFCB42", color: "#0A1736", fontWeight: "bold", '&:hover': { backgroundColor: "#E6B03D" } }}>
                    Get in Touch
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ContactUs;
